// src/utils/global.js
export const globalVars = {
  downloadUrl: 'http://nassforcecon.com:5000/d/s/1706416i3xJIxY9mY2dDGhe6vv7HIRnf/lCojG2nRvnpDeqYk9crVU8oyYl16QCy_-a7QAWPOC_ww'
}